import {analyticsLogEvent} from '../api'

interface Params {
    productId?: string
    selectedSizeLabel?: string
    boutiqueName?: string
    boutiqueId?: string
    redirectUrl?: string
}

/**
 * Tracks the selection of a size when opening the find in boutique drawer
 * without a preselected size.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.productId - The if of the selected variation group product.
 * @param {string} params.selectedSizeLabel - The label of the selected size.
 */
export function analyticsProductFindInBoutiqueSizeSelection({productId, selectedSizeLabel}: Params) {
    const eventDetails = {
        eventCategory: 'Find in Store',
        eventAction: 'Size Selected',
        eventLabel: `${productId} - ${selectedSizeLabel}`,
    }

    analyticsLogEvent('custom_event', eventDetails)
}

/**
 * Tracks the changes of country in the country selector.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.productId - The if of the selected variation group product.
 * @param {string} params.selectedSizeLabel - The label of the selected size.
 */
export function analyticsProductFindInBoutiqueCountryChange({productId, selectedSizeLabel}: Params) {
    const eventDetails = {
        eventCategory: 'Find in Store',
        eventAction: 'Change Country',
        eventLabel: `${productId} - ${selectedSizeLabel}`,
    }

    analyticsLogEvent('custom_event', eventDetails)
}

/**
 * Tracks the click on the call button of a boutique.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.productId - The if of the selected variation group product.
 * @param {string} params.selectedSizeLabel - The label of the selected size.
 * @param {string} params.boutiqueName - The name of the selected boutique.
 * @param {string} params.boutiqueId - The ID of the selected boutique.
 */
export function analyticsProductFindInBoutiqueCall({productId, selectedSizeLabel, boutiqueName, boutiqueId}: Params) {
    const eventDetails = {
        eventCategory: 'Find in Store',
        eventAction: 'Call',
        eventLabel: `${productId} - ${selectedSizeLabel}`,
        boutiqueName: `${boutiqueName} - ${boutiqueId}`,
    }

    analyticsLogEvent('custom_event', eventDetails)
}

/**
 *  * Tracks the click on the book appointment button of a boutique.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.productId - The if of the selected variation group product.
 * @param {string} params.selectedSizeLabel - The label of the selected size.
 * @param {string} params.boutiqueName - The name of the selected boutique.
 * @param {string} params.boutiqueId - The ID of the selected boutique.
 */
export function analyticsProductFindInBoutiqueBookAppointment({productId, selectedSizeLabel, boutiqueName, boutiqueId}: Params) {
    const eventDetails = {
        eventCategory: 'Find in Store',
        eventAction: 'Boutique Appointment',
        eventLabel: `${productId} - ${selectedSizeLabel}`,
        boutiqueName: `${boutiqueName} - ${boutiqueId}`,
    }

    analyticsLogEvent('custom_event', eventDetails)
}

/**
 * Tracks the redirect to a boutique details page triggered by the book appointment button.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.boutiqueName - The name of the selected boutique.
 * @param {string} params.boutiqueId - The ID of the selected boutique.
 * @param {string} params.redirectUrl - The link to the boutique details page.
 */
export function analyticsProductFindInBoutiqueRedirect({boutiqueName, boutiqueId, redirectUrl}: Params) {
    const eventDetails = {
        eventCategory: 'exclusive-service',
        eventAction: 'find-in-boutique',
        eventLabel: redirectUrl,
        boutiqueName: `${boutiqueName} - ${boutiqueId}`,
    }

    analyticsLogEvent('custom_event', eventDetails)
}

/**
 * Tracks the opening of the find in boutique drawer.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.productId - The if of the selected variation group product.
 */
export function analyticsProductFindInBoutiqueOpenLayer({productId}: Params) {
    const eventDetails = {
        eventCategory: 'Find in Store',
        eventAction: 'Open Layer',
        eventLabel: productId,
    }

    analyticsLogEvent('custom_event', eventDetails)
}
